export default "__VITE_ASSET__CxkiyMmL__"